import { Node } from '@tiptap/react';

export const ComputeExpressionNode = Node.create({
  name: 'node',
  group: 'block',
  content: 'inline*',
  addAttributes() {
    return {
      class: {
        default: 'compute-expression-node',
      },
    };
  },
  parseHTML() {
    return [{ tag: 'div' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 0];
  },
});
